// import ValidatePhoneInput from "./intl-phone-input";
// import {PhoneInputValue, SelectedPhoneCountry} from "./intl-phone-input";

// Search gmail : https://mail.google.com/mail/u/sikabyte@gmail.com/#search/currencyapi

let upgradeForm = document.getElementById('upgrade-to-promoter')
let upgradeFormActionUrl, upgradeType, secretCodeElem, currencyElem


// Fires immediately all deffered scripts are loaded and executed.
// Dom is ready but resources like images and iframes may not be loaded yet.
// You can use window.addEventListener('load' instead
document.addEventListener("DOMContentLoaded", (_) => {
    
});


// If not upgrade page, then don't validate.
// Though functions will still be accessible since they are hoisted to the top
// See: https://stackoverflow.com/a/11035042/16649244
// https://stackoverflow.com/questions/11034997/how-can-i-conditionally-define-a-function-in-javascript
if (upgradeForm !== null ){ // Then it's a upgrade page
    upgradeFormActionUrl = upgradeForm.action
    // upgradeType = (upgradeFormActionUrl.includes("partner") || 
    // upgradeFormActionUrl.includes("promoter") ) ? "advanced" : "simple"
    let upgradeTypeObj = document.getElementById("upgrade-type")
    if (upgradeTypeObj == null){
        upgradeType = "unknonwn"
    }else {
        upgradeType = upgradeTypeObj.textContent.trim()
    }
    console.log("upgradetype is", upgradeType)
    
    secretCodeElem = document.getElementById("secret-code") 
    currencyElem = document.getElementById("currency-select") 
    
    upgradeForm.addEventListener('submit', function(event) {
        event.preventDefault(); // Prevent the form from submitting
        let isValidated = true

        //Validate Secret Code
        let validSecretCodeInput = validateSecretCodeInput()
        if (!validSecretCodeInput){
            console.log("secret code did not pass validation");
            isValidated = false
            return false
        } 

        //Validate Currency Input
        let validCurrencySelectInput = validateCurrencySelectInput()
        if (!validCurrencySelectInput){
            console.log("currency input did not pass validation");
            isValidated = false
            return false
        } 
       
        // Submit the form manually
        if (isValidated) {
           SubmitUpgradeForm()
        }

        return isValidated
    });

    // Add listener for formdata event
    // You can change the form values here
    // For advanced form submission with formData check
    // https://javascript.info/formdata
    upgradeForm.addEventListener('formdata', (e) => {
        const formData = e.formData;
        //no need change document.getElementById().value = "";
        // formData.set('field1', 'foo');
        // formData.set('field2', 'bar');
        //updated formData
        console.log(formData)
    });



    if (secretCodeElem !== null) {    
        secretCodeElem.addEventListener('focusout', resetUpgradeError);
        // on keyup / change: reset
        secretCodeElem.addEventListener('change', resetUpgradeError);
        secretCodeElem.addEventListener('keyup', resetUpgradeError);    
    }
    function validateSecretCodeInput() {
        // Validate Secret Code Input for Advanced Upgrade

        if (secretCodeElem !== null){
            let secretCode = secretCodeElem.value;

            if (secretCode.length < 4 ) {
                // Display Upgrade Error
                let msg = "length of secret code should not be less than 4"
                ShowUpgradeError(msg)
                return false;
            }
            return true;
        }
        // if no gender element, return true
        return true;
    }

    if (currencyElem !== null) {    
        currencyElem.addEventListener('focusout', resetUpgradeError);
        // on keyup / change: reset
        currencyElem.addEventListener('change', resetUpgradeError);
        currencyElem.addEventListener('keyup', resetUpgradeError);    
    }

    function validateCurrencySelectInput() {
        // Validate Secret Code Input for Advanced Upgrade

        if (currencyElem !== null){
            let currency = currencyElem.value;

            if (currency == "" ) {
                // Display Upgrade Error
                let msg = "You haven't selected a currency"
                ShowUpgradeError(msg)
                return false;
            }
            return true;
        }
        // if no gender element, return true
        return true;
    }


}

function ShowUpgradeSuccess(msg) {
    let checkUpgradeSuccess = document.getElementById('check-upgrade-success')
    let checkUpgradeError = document.getElementById('check-upgrade-error')

    if (checkUpgradeError !== null ){
        checkUpgradeError.classList.add("hidden")
        checkUpgradeError.classList.remove("flex")
    }

    if (checkUpgradeSuccess !== null ){
        checkUpgradeSuccess.classList.add("flex")
        checkUpgradeSuccess.classList.remove("hidden")
    }

    console.log(msg)
    checkUpgradeSuccess.innerHTML = msg
    
}
function ShowUpgradeError(msg) {
    let checkUpgradeSuccess = document.getElementById('check-upgrade-success')
    let checkUpgradeError = document.getElementById('check-upgrade-error')

    if (checkUpgradeError !== null ){
        checkUpgradeError.classList.add("flex")
        checkUpgradeError.classList.remove("hidden")
    }

    if (checkUpgradeSuccess !== null ){
        checkUpgradeSuccess.classList.add("hidden")
        checkUpgradeSuccess.classList.remove("flex")
    }

    console.log(msg)
    checkUpgradeError.innerHTML = msg
    
}

function resetUpgradeError() {
    let checkUpgradeError = document.getElementById('check-upgrade-error')

    if (checkUpgradeError !== null ){
        checkUpgradeError.classList.add("hidden")
        checkUpgradeError.classList.remove("flex")
        checkUpgradeError.innerHTML = "";
    }
}

// https://javascript.info/formdata
// https://rapidapi.com/guides/error-handling-fetch
// https://stackoverflow.com/questions/39735496/redirect-after-a-fetch-post-call
async function SubmitUpgradeForm() {

    // Disable Upgrade Button
    let upgradeButton = document.getElementById("upgrade-button")
    upgradeButton.disabled = true;

    // let upgradeFormData = new FormData(upgradeForm)
    // console.log("upgrade form data: ", upgradeFormData)

    // // let secretCode = ''+secretCodeElem.value+'';
    // // upgradeFormData.append("secret_code", secretCode);
    // upgradeFormData.append("ucode", secretCodeElem.value);

    // console.log("The UpgradeFormAction Url is: ", upgradeFormActionUrl)

    // let upgradeFormPostData = new URLSearchParams(upgradeFormData)

    let customerToPromoterUpgradeObject = {
        secret_code: secretCodeElem.value,
        currency: currencyElem.value
    }

    let upgradeResponse = fetch(upgradeFormActionUrl, {
        "method": "POST",
        body: JSON.stringify(customerToPromoterUpgradeObject),
        mode: 'cors',
        // redirect:'manual',
        headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Access-Control-Allow-Origin': '*',
        },
    })
    .then(response => {

        upgradeButton.disabled = false; 
        
        if (response.type == "opaqueredirect"){  
            // ensure to set redirect:'manual', in fetch's config to use this option
            // default is follow redirect which will create two requests
            // To make sure the fetch is with redirect response return. 
            // response.url here is still that of the post action. Only use if you want
            // to set your redirect url by yourself 
            //   window.location.replace(response.url); // create one and only one request
            //   return;
        }
        // There is also response.status
        // if (!(response.ok || response.status >= 500  || response.redirected)) {
        if (response.status >= 500) {
            throw new Error('Server error');
        }
        // Follow redirects if redirected from server
        if (response.redirected) {
            // Since backend creates session and redirects to page, then 
            window.location.href = response.url;
            return true
        }
        return response.json();
    })
    .then(data => {
        // Do something with the data
        console.log(data.message) 
        if (!data.error) {
            ShowUpgradeSuccess(data.message)

            setTimeout(function() {
                // redirect to next (should be dashboard)
                if (data.hasOwnProperty('data')) {
                    window.location.href = data.data.next;
                }
            }, 2000)

            return data
        } else {
            ShowUpgradeError(data.message)
            return false
        } 
    })
    .catch(error => {   
        let msg = "Error occurred during sign up: " + error 
        upgradeButton.disabled = false;
        ShowUpgradeError(msg)
        // console.error(msg);
    });

    let upgradeSuccess = await upgradeResponse
    return upgradeSuccess
}











